export const AUTH_SESSION_CHANGED_EVENT = "canteen-session-changed";

const ACCESS_TOKEN_KEY = "token";
const REFRESH_TOKEN_KEY = "refreshToken";
const USER_DETAILS_KEY = "userDetails";

const parseJson = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

const toArray = (value) => (Array.isArray(value) ? value : []);

export const getTenantId = () => process.env.REACT_APP_TENANT_ID || "";

export const getTenantIdForPayload = () => {
  const tenantId = getTenantId();
  const numericTenantId = Number(tenantId);

  return tenantId !== "" && Number.isFinite(numericTenantId)
    ? numericTenantId
    : tenantId;
};

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY) || "";

export const getRefreshToken = () =>
  localStorage.getItem(REFRESH_TOKEN_KEY) || "";

export const getStoredUserDetails = () =>
  parseJson(localStorage.getItem(USER_DETAILS_KEY));

export const buildUserDetails = (authResponse, previousUserDetails = {}) => ({
  UserId: authResponse?.UserId ?? previousUserDetails?.UserId ?? null,
  name: authResponse?.name ?? previousUserDetails?.name ?? "",
  firstName: authResponse?.firstName ?? previousUserDetails?.firstName ?? "",
  lastName: authResponse?.lastName ?? previousUserDetails?.lastName ?? "",
  email: authResponse?.email ?? previousUserDetails?.email ?? "",
  isDeleted: authResponse?.isDeleted ?? previousUserDetails?.isDeleted ?? null,
  isVerified:
    authResponse?.isVerified ?? previousUserDetails?.isVerified ?? false,
  tenant_id:
    authResponse?.tenant_id ??
    previousUserDetails?.tenant_id ??
    getTenantIdForPayload(),
  verificationToken:
    authResponse?.verificationToken ??
    previousUserDetails?.verificationToken ??
    null,
  tenantName: authResponse?.tenantName ?? previousUserDetails?.tenantName ?? "",
  Role: authResponse?.Role
    ? toArray(authResponse.Role)
    : toArray(previousUserDetails?.Role),
});

export const buildAuthSession = (authResponse) => {
  const previousUserDetails = getStoredUserDetails() || {};

  return {
    accessToken: authResponse?.jwtToken || "",
    refreshToken: authResponse?.refreshToken || "",
    userDetails: buildUserDetails(authResponse, previousUserDetails),
  };
};

export const saveAuthSession = (authResponse) => {
  const session = buildAuthSession(authResponse);

  if (session.accessToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, session.accessToken);
  }

  if (session.refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, session.refreshToken);
  }

  localStorage.setItem(USER_DETAILS_KEY, JSON.stringify(session.userDetails));

  return session;
};

export const clearAuthSession = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_DETAILS_KEY);
};

export const notifyAuthSessionChanged = () => {
  window.dispatchEvent(new Event(AUTH_SESSION_CHANGED_EVENT));
};

